/**
 * Coup de pouce, Attendu 1222 « simplifier une fraction dont le numérateur
 * et le dénominateur sont dans une même table de multiplication, par
 * exemple 15/35 » (3e, Multiples et diviseurs, l. 782). Seconde passe 3e
 * (2026-09-13). UNE page STATIQUE partagée par les trois clés.
 *
 * L'image que l'élève a déjà : la fraction écrite en produits (4e, l. 660
 * « simplifier une fraction » ; 5e, fractions égales : on multiplie ou on
 * divise le haut et le bas par le même nombre). 15 = 3 × 5 et 35 = 7 × 5,
 * le 5 commun en orange, barré ; il reste 3/7. Vérification : 3 et 7 n'ont
 * plus de table commune, c'est fini.
 *
 * SACRIFIÉ : 15/35 (3, 7 ; 5), l'exemple du programme, sur tout ce qui
 * s'affiche (gen1222.self.test.js).
 */
import { svg, frac, op } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
/** Un « 3 × 5 » avec le 5 en orange barré. */
const produit = (a) => `<tspan fill="${BLEU}">${a}</tspan> × <tspan fill="${ORANGE}" text-decoration="line-through">5</tspan>`;

const SVG = svg(
    '15 sur 35. 15 égale 3 fois 5, 35 égale 7 fois 5 : tous les deux dans la table de 5. Le 5 est barré en haut et en bas. Il reste 3 sur 7. 3 et 7 n’ont plus de table commune : c’est fini.',
    `<!-- 1. la fraction, puis en produits, puis simplifiée -->
  ${frac(60, 74, 15, 35, ENCRE, 18, 14)}
  ${op(98, 80, '=')}
  ${frac(170, 74, produit(3), produit(7), ENCRE, 16, 30)}
  ${op(242, 80, '=')}
  ${frac(280, 74, 3, 7, BLEU, 18, 13)}

  <!-- 2. le geste -->
  ${ligne(140, `15 = 3 × <tspan fill="${ORANGE}" font-weight="bold">5</tspan> et 35 = 7 × <tspan fill="${ORANGE}" font-weight="bold">5</tspan> : tous les deux dans la table de 5.`, 12)}
  ${ligne(164, 'Je divise le haut et le bas par 5.', 13)}
  ${ligne(190, '3 et 7 n’ont plus de table commune : c’est fini.', 12, GRIS)}`,
    206,
);

const AIDE = { pages: [{ titre: 'Tous les deux dans la table de 5', svg: SVG }] };

const CP_1222 = {
    flash_texte_trou_saisie: AIDE,
    simplifiee_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1222;
